import {
  call,
  put,
  select,
  takeEvery
}                               from 'redux-saga/effects';
import service                  from '../../services';
import {
  deleteBookmark,
  getBookmarks
} from "../bookmarks/actions";
import { openWarningException } from "../layouts/actions";

import { resetExportPoints }      from "../recordings/actions";
import { chooseServiceGenerator } from "./utils";

function* exportBookmarkSaga(action) {
  const {startTime, duration, pane, data, locationPathname} = action;

  const state = yield select(state => state);
  const {token, bkmsInfo} = state.API;
  const cameraId = locationPathname === 'bookmarks' ? state.bookmarks.bookmarks[pane].id : state.browse.browsePanes[pane].id;

  if (bkmsInfo && data) {
    const searchedClassification = bkmsInfo.classifications.find(item => data.classification === item.name);
    data.classificationId = searchedClassification ? searchedClassification.id : null;
    data.classificationName = data.classification;

    const searchedCase = bkmsInfo.cases.find(item => item.name === data.caseName);
    data.cassesId = searchedCase ? searchedCase.id : null;
    data.caseName = bkmsInfo.cases.length ? data.caseName : null;
  }

  data.tags = data.tags.split(' ').join(',');

  try {
    yield put(resetExportPoints());
    yield call(() =>
      service.createBookmark({token, start: startTime, end: startTime + duration, id: cameraId, data}));
    yield put(getBookmarks());
  } catch (e) {
    try {
      yield onError('Exports failed... ' + e.response.data.msg);
    } catch (e) {
      // console.log('no e.response.data.MSG')
    }
  }
}

function* exportAviSaga(action) {
  const {startTime, duration, pane, locationPathname} = action;

  const state = yield select(state => state);
  const {token} = state.API;
  const {mode} = state.recording;
  const cameraId = locationPathname === 'bookmarks' ? state.bookmarks.bookmarks[pane].id : state.browse.browsePanes[pane].id;

  const isBookmarkMode = mode === 'bookmarks';
  try {
    isBookmarkMode
      ? yield call(exportBookmarkSaga, action)
      : yield call(service.doExportAvi, {token, start_time: startTime, duration, pane, cameraId});

    yield put(resetExportPoints());
  } catch (e) {
    try {
      yield onError('Exports failed... ' + e.response.data.msg);
    } catch (e) {
      // console.log('no e.response.data.MSG')
    }
  }
}

function* cayugaBookmarkSaga(action) {
  const {startTime, pane, data, bkmsId} = action;
  const {browsePanes} = yield select(state => state.browse);
  const {token} = yield select(state => state.API);
  const {mode} = yield select(state => state.recording);

  const camId = browsePanes?.[pane]?.id;
  try {
    switch (mode) {
      case 'createBookmark':
        const cRes = yield call(service.createBookmark, {token, id: camId, timestamp: startTime, data})
        if (cRes.error) {
          return console.log(cRes.data);
        }
        break;
      case 'updateBookmark':
        const uRes = yield call(service.createBookmark, {token, id: camId, timestamp: startTime, data, bookmarkID: bkmsId[0]})
        if (uRes.error) {
          return console.log(uRes.data);
        }
        break;
      case 'deleteBookmark':
        yield put(deleteBookmark(bkmsId));
        break;
      default:
        break;
    }

  } catch (e) {
    console.log(e);
  } finally {
    yield put(getBookmarks(pane));
    yield put(resetExportPoints());
  }
}

function* onError(msg) {
  yield put(openWarningException(msg))
}

export default function* () {
  yield takeEvery('doExportFile', chooseServiceGenerator,
    {fn: exportAviSaga, args: []},
    {fn: cayugaBookmarkSaga, args: []}
  );
}